interface DropdownItem {
	value: string;
	label: string;
}

interface AutocompleteDropdownProps {
	isOpen: boolean;
	searchValue: string;
	items: (string | DropdownItem)[];
	onSelect: (value: string) => void;
}

export const AutocompleteDropdown = ({
	isOpen,
	searchValue,
	items,
	onSelect,
}: AutocompleteDropdownProps) => {
	if (!isOpen || searchValue.trim().length === 0 || items.length === 0) {
		return null;
	}

	return (
		<div className="absolute top-full left-0 right-0 z-50 bg-[#1E2748] border border-[#506296] rounded-[20px] mt-1 max-h-[160px] overflow-y-auto shadow-lg">
			{items.map((item, idx) => {
				const isObject = typeof item === 'object' && item !== null;
				const key = isObject ? item.value : `${item}-${idx}`;
				const label = isObject ? item.label : item;

				return (
					<button
						key={key}
						type="button"
						onClick={() => onSelect(label)}
						className="w-full text-left px-4 py-2.5 text-white hover:bg-[#2667FF]/20 text-sm transition-colors border-b border-[#2D3A6C] last:border-b-0"
					>
						{label}
					</button>
				);
			})}
		</div>
	);
};
